import { loadStripe } from "@stripe/stripe-js/pure";
import type { LockerverseStripeLoader } from "./types.ts";

const stripeLoads = new Map<
  string,
  Map<string | null, ReturnType<LockerverseStripeLoader>>
>();

export const defaultLockerverseStripeLoader: LockerverseStripeLoader = (
  publishableKey,
  options
) => {
  const connectedAccountId = options?.stripeAccount ?? null;
  let accountLoads = stripeLoads.get(publishableKey);
  if (!accountLoads) {
    accountLoads = new Map();
    stripeLoads.set(publishableKey, accountLoads);
  }

  const existingLoad = accountLoads.get(connectedAccountId);
  if (existingLoad) {
    return existingLoad;
  }

  const stripeLoad = loadStripe(publishableKey, options)
    .catch(() => null)
    .then((stripe) => {
      if (stripe) {
        return stripe;
      }
      if (accountLoads?.get(connectedAccountId) === stripeLoad) {
        accountLoads.delete(connectedAccountId);
        if (accountLoads.size === 0) {
          stripeLoads.delete(publishableKey);
        }
      }
      return null;
    });
  accountLoads.set(connectedAccountId, stripeLoad);
  return stripeLoad;
};
